import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

import af from './af'
import st from './st'
import ap from './ap'
import kk from './kk'
import pk from './pk'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      props: true,
      component: () => import(/* webpackChunkName: "index" */ '@/views/Index.vue')
    },
    {
      path: '/innlogging',
      name: 'login',
      props: true,
      component: () => import(/* webpackChunkName: "login" */ '@/views/Login.vue')
    },
    {
      path: '/nullstill-passord',
      name: 'reset-password',
      component: () => import(/* webpackChunkName: "reset-password" */ '@/views/ResetPassword.vue')
    },
    {
      path: '/endre-passord',
      name: 'change-password',
      component: () => import(/* webpackChunkName: "change-password" */ '@/views/ChangePassword.vue'), props: (route) => ({ email: route.query.email, keyCode: route.query.keyCode })
    },

    ...af,
    ...st,
    ...ap,
    ...kk,
    ...pk

  ]

})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.accessToken) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

export default router